/**
 * AdminIzinTalepleri.jsx
 *
 * Admin/superadmin izin talepleri ekranı — ŞİMDİLİK BOŞ DURUM.
 * Kapsam dışı: bu fazda backend endpoint'i, veri modeli ya da izin talebi
 * mantığı yok. Sadece tasarımdaki yeri ve navigasyondaki görünürlüğü
 * korumak için boş durum kartı gösterir.
 *
 * Route: /admin/izin-talepleri
 * Sonraki fazda: liste + onay/red akışı buraya eklenecek.
 */
import AdminLayout from '../components/admin/AdminLayout';
import { useLanguage } from '../contexts/LanguageContext';
import { CalendarClock } from 'lucide-react';

export default function AdminIzinTalepleri() {
  const { lang } = useLanguage();
  const tr = (t, e) => (lang === 'tr' ? t : e);

  return (
    <AdminLayout>
      <div className="-m-4 lg:-m-6 p-4 lg:p-6 min-h-full" style={{ backgroundColor: 'var(--crm-cream)' }}>
        {/* Başlık */}
        <div className="mb-5">
          <nav className="mb-1 text-xs font-semibold" style={{ color: 'var(--crm-muted-2)' }}>
            Admin <span className="mx-1">/</span> {tr('İzin Talepleri', 'Leave Requests')}
          </nav>
          <h1 className="text-2xl font-bold flex items-center gap-2" style={{ color: 'var(--crm-navy-text)' }}>
            <CalendarClock size={22} style={{ color: 'var(--crm-navy)' }} />
            {tr('İzin Talepleri', 'Leave Requests')}
          </h1>
        </div>

        {/* Boş durum kartı */}
        <div className="bg-white p-8 text-center" style={{ borderRadius: 14, border: '1px solid var(--crm-card-border)' }}>
          <CalendarClock size={32} className="mx-auto mb-2" style={{ color: 'var(--crm-muted-2)' }} />
          <p className="text-sm font-semibold" style={{ color: 'var(--crm-muted)' }}>
            {tr('Bu bölüm henüz aktif değil — sonraki fazda açılacak.', 'This section is not active yet — it will be enabled in a future phase.')}
          </p>
        </div>
      </div>
    </AdminLayout>
  );
}
